import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface HidayetGunesiProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const HidayetGunesi = (props: HidayetGunesiProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h3 className="title">ALLAH'IN HİDAYET GÜNEŞİ</h3>
                <p>
                    <span className="sub-title">HİDAYET : GÖNÜL</span> pusulasının hakikat kıblesini
                    yakalama ânıdır. Hidayet, âşıkın maşuka kavuşma hâlidir.
                    Hidayet, bir ömür boyu her gün üşenmeden gönül
                    penceremize gelip perdelerin aralanmasını bekleyen
                    iman güneşinin nazlı nazlı içeri süzülme fırsatıdır.
                    Hidayet, dünyada hiçbir nimet ve servetle ölçülemeyen
                    ve hatırası bir ömür boyu tüm tazeliğiyle burunda buram
                    buram tüten bir mazhariyet sevincidir. Kısacası,
                    “hidayet, büyük bir nimet, vicdanî bir lezzet ve ruhun
                    cennetidir.”
                </p>
                <p>
                    Yüce Allah, insanoğlunun hayat serüveninin her
                    aşamasında hidayetini dilemiştir. Bunun için gerekli
                    her türlü imkânı lütfetmiş, şartları ona göre hazırlamıştır.
                    Nitekim henüz dünyaya gözlerini açmamış
                    olan insanoğlunu bulunduğu ortamda ihtiyacı yokken
                    dokuz ay sonrasında ayak basacağı dünya hayatı için
                    gerekli olan her türlü duyu ve duyguyla donatmıştır.
                    Dünyaya gelişini kolaylaştırmış, doğar doğmaz, bir süt
                    çeşmesi gibi devreye giren, annesinin şefkatli sinesinden
                    istifade refleksini bahşetmiştir.
                </p>

                <p>
                    Her birisi ayrı bir nimet dünyası olan tatlar, sesler,
                    renkler, hoş kokular vb. defineleri açacak anahtarları
                    eline vererek bunlardan istifade yolunu göstermiştir.
                    En az bunlar kadar önemli, âlemi donattığı, her taşına
                    hatta her zerresine nakşettiği hikmet inceliklerini kavrayıp
                    yararlanacak aklı ihsan etmiştir. Gözünün görmesi
                    için güneşi, kulağının işitmesi ve burnunun koku
                    alması için hava zerrelerini hizmetine vermiştir. Tüm
                    bunlar, Yüce Allah’ın istisnasız bütün kullarına, hatta
                    bütün canlılara en iyiye, en güzele ve en faydalıya yönelik
                    yol gösterme arzu ve iradesine delildir.
                </p>
                <p>
                    Yüce Allah, hidayet alanındaki lütuf ve nimetlerini
                    bununla da sınırlı tutmamış, ayrıca yerleri, gökleri ve
                    içindeki tüm sanat eserlerini, ilim ve hikmet incelikleriyle
                    bezeyerek Kendine ulaştıracak, kapısına vardıracak
                    birer işaret ve delil gibi bayrak bayrak dalgalandırmıştır.
                    Kur’an’da, evrene “âlem” denmesinin sebebi,
                    belki de Yüce Sanatkârına her zerresiyle alâmet ve işaret
                    olmasından dolayıdır.
                </p>
                <p>
                    Bu rehberlik ve yol göstericilere ilaveten yine de kullarının
                    elini bırakmamış, onlara belli aralıklarla kendi
                    hem cinslerinden manevî rehber ve önderler göndermiş,
                    yani peygamberleri görevlendirmiştir. Ayrıca bu
                    peygamberlerin elinde bir program şeklinde bulunan
                    ve vefatlarından sonra da ümmetlerine yol gösterecek
                    tarzda küçüklü, büyüklü kitaplar indirmiştir.
                </p>
                <p>
                    Buraya kadar olan İlahî rehberlik ve yol göstericilik,
                    genel, yani istisnasız olarak tüm insanlar için geçerli5
                    dir. Deyim yerindeyse, Yüce Allah, tüm kullarının önüne
                    doya doya istifade edecekleri mükellef bir hidayet
                    sofrası sermiştir.
                </p>
                <p>
                    Ne yazık ki kulların hepsi bu hidayet sofrasına aynı
                    şekilde ilgi gösterip gereği gibi ondan yararlanma yoluna
                    gitmemiş, hatta büyük bir kısmı özellikle kâinatta
                    dalgalanan tevhid delillerine ve bunların tercümanı
                    olan peygamber ve kitaplara hiç iltifat etmemişlerdir.
                    Yüce Allah, tüm bu vesilelerle hidayetinin güneşini, her
                    zaman, gönül odalarının pencerelerini kadar getirmiş,
                    fakat pek çoğu, gaflet ve cehalet perdelerim aralama
                    zahmetine katlanmayarak o latif ve ruh okşayıcı ışığın
                    içeri süzülmesine engel olmuştur. Buna karşın, hayatlarının
                    ta ilk adımlarından itibaren İlahî inayetin bu
                    yol göstericiliğini sezenler, bundan Rabb’inin iradesi
                    doğrultusunda büyük bir manevî haz ve gönül dolusu
                    şükranla yararlanmaya çalışanlar, gelen peygamber ve
                    kitapları da birer manevî ışık gibi görüp istifade edenler
                    de olmuştur.
                </p>

                <p>
                    Yüce Allah da hidayetini o gönüllerde gerçekleştirip
                    onları hedefine ulaştırmıştır. Diğer deyişiyle onlara
                    iman nasip etmiş, onları hakikate eriştirmiştir. Bu anlamda
                    Allah’tan başka hidayet edici yoktur.
                </p>

                <p>
                    İman hidayetinin de bir meyvesi ve mükâfatı vardır
                    ki bu da Kur’an dilinde “hidayet” olarak nitelenmiştir:
                    Ebedî nimetler diyarı olan cennete ulaşma!.. Kur’an, bir
                    yerde cennetliklerin gıpta edilesi hâllerini tasvir etmekte
                    ve bu gerçeği onların dilinden seslendirmektedir:
                </p>

                <p>
                    “İman edip makbul ve güzel işler yapanlar ise ki hiç
                    kimseye Biz gücünün yetmeyeceği yükü yüklemeyiz
                    cennetlik olup orada ebedî kalacaklardır. Öyle bir hâlde
                    ki içlerinde kin kabilinden ne varsa hepsini söküp
                    çıkarmışızdır, Önlerinden ırmaklar akar. ‘Hamd olsun
                    bizi bu cennete eriştiren Allah’a! Eğer Allah bizi muvaffak
                    kılmasaydı kendiliğimizden biz yol bulamazdık.
                    Rabb’imizin elçilerinin gerçeği bildirdikleri bir kere
                    daha kesinlikle anlaşılmıştır’ derler. Kendilerine de
                    İşte güzel işlerinize karşılık, karşınızda duran şu muhteşem
                    cennete varis kılındınız, buyurun!’ diye nida edilir.”
                    <span className="text-bold"> (A’râf Suresi, 7:42-43.)</span>
                </p>


            </article>
        </div>
    );
}

export default HidayetGunesi;